module.exports = __webpack_public_path__ + "img/4.0bc7db4d.jpg";